/* src/app/front-layout/eight-week-combined/eight-week-combined.component.css */
.apple-gradient {
  font-size: 48px;
  font-weight: 550;
  text-align: center;
  background:
    linear-gradient(
      270deg,
      #ff0057,
      #ff7c00,
      #ffee00,
      #00ff85,
      #00cfff,
      #8f00ff,
      #ff0057);
  background-size: 200% auto;
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  animation: shine 5s linear infinite;
}
@keyframes shine {
  0% {
    background-position: 0% center;
  }
  100% {
    background-position: 200% center;
  }
}
.spacer {
  height: 50px;
}
.ew-hero {
  background:
    linear-gradient(
      135deg,
      #fdfdfd 0%,
      #e3f2fd 20%,
      #e1f5fe 50%,
      #f3e5f5 80%,
      #fffde7 100%);
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  margin: 0;
  font-family: "Segoe UI", sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.hro-head {
  font-size: 64px;
  color: black;
  font-weight: 500;
}
.course-head {
  font-size: 28px;
  background:
    linear-gradient(
      90deg,
      #F67F07 0%,
      #AE35FF 33%,
      #F83E96 63%,
      #07DEF6 100%);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
}
.hro-head span {
  font-size: 64px;
  font-weight: 500;
  text-align: center;
  background:
    linear-gradient(
      270deg,
      #ff0057,
      #ff7c00,
      #ffee00,
      #00ff85,
      #00cfff,
      #8f00ff,
      #ff0057);
  background-size: 200% auto;
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  animation: shine 5s linear infinite;
}
@keyframes shine {
  0% {
    background-position: 0% center;
  }
  100% {
    background-position: 200% center;
  }
}
.ew-hero h4 {
  text-align: center;
  font-size: 20px;
  width: 70%;
}
.cta-1 {
  width: 250px;
  margin: 20px;
  background:
    linear-gradient(
      270deg,
      #ff0057,
      #ff7c00,
      #ffee00,
      #00ff85,
      #00cfff,
      #8f00ff,
      #ff0057);
  background-size: 400% 400%;
  animation: shine-bg 6s linear infinite;
  color: rgb(11, 11, 11);
  border: none;
  border-radius: 30px;
  padding: 16px 32px;
  text-align: center;
  font-size: 22px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.3s ease;
}
@keyframes shine-bg {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 100% 50%;
  }
}
.hex-stroke {
  width: 100%;
  margin-top: -300px;
}
.hexp-img {
}
.cta-1-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.ew-explore {
  margin-top: -50px;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.ew-explore h1 {
  margin-left: 55px;
  font-size: 54px;
  font-weight: 600;
  background:
    linear-gradient(
      90deg,
      #07DEF6 0%,
      #AE35FF 33%,
      #F83E96 63%,
      #F67F07 100%);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  display: inline-block;
}
.ew-explore h3 {
  margin-left: 55px;
  font-size: 28px;
  font-weight: 500;
}
.ew-explore h3 span {
  background:
    linear-gradient(
      90deg,
      #07DEF6 0%,
      #AE35FF 33%,
      #F83E96 63%,
      #F67F07 100%);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  display: inline-block;
}
.ew-explore-cards {
  margin-top: -100px;
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 40px;
  padding: 40px;
}
.ew-explore-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 25px;
}
.ew-explore-card img {
  width: 100%;
  height: auto;
}
.wmd-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.wmd-container h1 {
  font-size: 40px;
  font-weight: 600;
  margin-bottom: 25px;
}
.wmd-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  flex-wrap: wrap;
  gap: 40px;
  padding: 40px;
}
.wmd-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 350px;
  border-radius: 20px;
  padding: 20px;
  box-shadow: 0 10px 24px rgba(138, 21, 255, 0.1);
}
.wmd-card img {
  width: 100%;
  height: auto;
}
.wmd-card h4 {
  font-size: 28px;
  font-weight: 600;
  margin: 20px;
  text-align: center;
  background:
    linear-gradient(
      90deg,
      #07DEF6 0%,
      #AE35FF 33%,
      #F83E96 63%,
      #F67F07 100%);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  display: inline-block;
}
.wmd-card p {
  text-align: center;
}
.prog-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.prog-cont-head {
  margin-top: 50px;
  font-size: 40px;
  font-weight: 600;
}
.prog-cont-head span {
  background:
    linear-gradient(
      90deg,
      #07DEF6 0%,
      #AE35FF 33%,
      #F83E96 63%,
      #F67F07 100%);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  display: inline-block;
}
.hex-stroke2 {
  width: 100%;
}
.progs-cards {
  margin-top: -450px;
  display: flex;
  align-items: center;
  gap: 100px;
  padding: auto;
  margin-bottom: 25px;
}
.progs-card {
  height: 550px;
  background:
    linear-gradient(
      180deg,
      #f6f0ff,
      #d48aff,
      #a54fff);
  padding: 20px;
  border-radius: 20px;
  color: black;
  width: 450px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  display: flex;
  align-items: center;
}
.gradient-card:hover {
  transform: translateY(-10px);
}
.progs-card img {
  width: 100%;
  height: 300px;
  border-radius: 20px;
  object-fit: cover;
}
.pc-p {
  color: white;
  margin: 20px;
  font-size: 28px;
  text-align: center;
  font-weight: 600;
}
.pc-p2 {
  color: white;
  font-size: 18px;
  text-align: center;
}
.section-breakdown {
  max-width: 80%;
  margin: 0 auto 56px auto;
  padding: 0 12px;
}
.section-breakdown h2 {
  text-align: center;
  font-size: 4rem;
  margin: 36px 0 28px 0;
  font-weight: 600;
  color: #151515;
}
.accordion {
  width: 100%;
}
.accordion-item {
  background: #9114FF;
  border: 1px solid #ececec;
  border-radius: 2px;
  margin-bottom: 18px;
  overflow: hidden;
  color: white;
  transition: box-shadow 0.22s;
}
.accordion-item.open {
  background: #9114FF;
  box-shadow: 0 3px 18px rgba(70, 70, 70, 0.04);
}
.accordion-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 18px 24px 18px 16px;
  background: rgba(0, 0, 0, 0.04);
  font-size: 2rem;
  font-weight: 600;
  border-bottom: 1px solid #ededed;
  -webkit-user-select: none;
  user-select: none;
  transition: background 0.18s;
}
.accordion-item:not(.open) .accordion-header {
  border-bottom: none;
}
.accordion-header:hover {
  background: #efeae7;
  color: black;
}
.accordion-icon {
  transition: transform 0.33s cubic-bezier(.45, 1.59, .42, .98);
}
.accordion-item.open .accordion-icon {
  transform: rotate(180deg);
}
.accordion-content {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  padding: 0 24px;
  background: #fff;
  font-size: 1.5rem;
  color: #181818;
  transition: all 0.36s cubic-bezier(.55, 1.76, .51, 1);
}
.accordion-item.open .accordion-content {
  max-height: 900px;
  opacity: 1;
  padding: 18px 24px 20px 24px;
  border-top: none;
}
.accordion-content ul {
  margin: 0 0 10px 0;
  padding-left: 20px;
}
.accordion-content li {
  margin-bottom: 7px;
  font-weight: 300;
}
.cm-cont {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.cm-cont h1 {
  font-size: 40px;
  font-weight: 600;
  margin-top: 50px;
}
.cm-card {
  display: flex;
  align-items: center;
  width: 80%;
  padding: 20px;
  margin: 20px;
  background-color: #ffffff;
  border-radius: 20px;
  box-shadow: 0 10px 24px rgba(138, 21, 255, 0.1);
}
.cm-card-right {
  width: 70%;
  display: flex;
  flex-direction: column;
}
.cm-card-left {
  width: 30%;
}
.cm-card img {
  width: 100%;
}
.cmc-h {
  font-size: 24px;
  font-weight: 600;
}
.cmc-p {
  font-size: 18px;
}
.wtp-cont {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.wtp-cont h1 {
  font-size: 40px;
  font-weight: 600;
}
.ptm-container {
  display: flex;
  align-items: center;
  background:
    linear-gradient(
      135deg,
      #fdfdfd 0%,
      #e3f2fd 20%,
      #e1f5fe 50%,
      #f3e5f5 80%,
      #fffde7 100%);
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 24px;
  box-shadow: 0 10px 24px rgba(138, 21, 255, 0.1);
  overflow: hidden;
  max-width: 1200px;
  margin: auto;
}
.ptm-content {
  flex: 1;
  padding: 30px;
  font-size: 20px;
  color: #000;
}
.ptm-content .highlight {
  font-weight: 600;
  color: #7416f9;
}
.ptm-image img {
  max-width: 450px;
  height: auto;
  border-top-right-radius: 24px;
  border-bottom-right-radius: 24px;
  display: block;
}
.end-cont {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.end-head {
  font-size: 48px;
  font-weight: 600;
  background:
    linear-gradient(
      90deg,
      #07DEF6 0%,
      #AE35FF 33%,
      #F83E96 63%,
      #F67F07 100%);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  display: inline-block;
}
@media (max-width: 1200px) {
  .ew-explore h1 {
    font-size: 44px;
  }
  .ew-explore-cards {
    gap: 20px;
  }
  .wmd-cards {
    grid-template-columns: repeat(2, 1fr);
  }
  .progs-cards {
    gap: 50px;
  }
}
@media (max-width: 992px) {
  .ew-hero h4 {
    width: 85%;
  }
  .hex-stroke {
    margin-top: -200px;
  }
  .ew-explore h1 {
    margin-left: 30px;
  }
  .ew-explore h3 {
    margin-left: 30px;
  }
  .progs-card {
    height: 500px;
    width: 400px;
  }
}
@media (max-width: 768px) {
  .spacer {
    height: 30px;
  }
  .ew-hero {
    text-align: center;
  }
  .hro-head,
  .hro-head span {
    font-size: 42px;
    line-height: 1.2;
  }
  .course-head {
    font-size: 18px;
  }
  .ew-hero h4 {
    width: 90%;
    font-size: 18px;
  }
  .hex-stroke {
    margin-top: -150px;
  }
  .ew-explore h1 {
    margin-top: 50px;
    font-size: 36px;
    margin-left: 0;
    text-align: center;
  }
  .ew-explore h3 {
    font-size: 24px;
    margin-left: 0;
    text-align: center;
  }
  .ew-explore-cards {
    flex-direction: column;
    margin-top: 10px;
    gap: 30px;
  }
  .ew-explore-card {
    max-width: 400px;
  }
  .wmd-container h1 {
    font-size: 32px;
  }
  .wmd-cards {
    grid-template-columns: 1fr;
    padding: 20px;
  }
  .prog-cont-head {
    margin-top: 25px;
    font-size: 32px;
    text-align: center;
    padding: 0 20px;
  }
  .progs-cards {
    padding: 20px;
    flex-direction: column;
    margin-top: -150px;
    gap: 40px;
  }
  .progs-card {
    width: 100%;
    max-width: 450px;
    height: auto;
  }
  .section-breakdown {
    max-width: 95%;
  }
  .accordion-header {
    font-size: 1.6rem;
    padding: 14px 20px;
  }
  .cm-cont h1 {
    font-size: 32px;
    text-align: center;
    padding: 0 20px;
  }
  .cm-card {
    flex-direction: column;
    width: 90%;
  }
  .cm-card-right,
  .cm-card-left {
    width: 100%;
  }
  .cm-card-left img {
    margin-top: 20px;
  }
  .wtp-cont {
    padding: 20px;
  }
  .wtp-cont h1 {
    font-size: 32px;
    text-align: center;
  }
  .ptm-container {
    flex-direction: column;
    padding: 20px;
  }
  .ptm-content {
    padding: 20px;
    font-size: 18px;
  }
  .ptm-image img {
    max-width: 100%;
    border-radius: 0 0 24px 24px;
  }
  .end-head {
    font-size: 32px;
    text-align: center;
    padding: 0 20px;
  }
}
@media (max-width: 480px) {
  .hro-head,
  .hro-head span {
    font-size: 32px;
  }
  .ew-hero h4 {
    font-size: 16px;
  }
  .cta-1 {
    width: 200px;
    padding: 12px 24px;
    font-size: 18px;
  }
  .hex-stroke {
    margin-top: -100px;
  }
  .ew-explore h1 {
    font-size: 28px;
  }
  .ew-explore h3 {
    font-size: 20px;
  }
  .prog-cont-head {
    font-size: 24px;
  }
  .progs-card {
    padding: 15px;
  }
  .pc-p {
    font-size: 22px;
  }
  .accordion-header {
    font-size: 1.4rem;
  }
  .cm-cont h1 {
    font-size: 24px;
  }
  .cmc-h {
    font-size: 20px;
  }
  .wtp-cont h1 {
    font-size: 24px;
  }
  .end-head {
    font-size: 24px;
  }
}
/*# sourceMappingURL=eight-week-combined.component.css.map */
